import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, Grid, Typography, useTheme } from '@material-ui/core';
import { DIRECTIONS } from 'helpers/variables';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useIsDesktop } from 'components/utilities';

// Import styles
import { useStyles } from './styles';

const InfoListItem = ({
	title,
	info,
	icon: Icon,
	icon2: Icon2,
	hasAction = true,
	...restProps
}) => {
	const { direction } = useTheme();

	const classes = useStyles();

	const isDesktop = useIsDesktop();

	return (
		<ListItem {...restProps}>
			<Grid
				container
				spacing={2}
				justify="space-between"
				alignItems="center"
				wrap="nowrap"
			>
				<Grid
					item
					xs={isDesktop ? 5 : 'auto'}
					container
					spacing={1}
					alignItems="center"
				>
					<Grid item xs="auto" className={classes.iconContainer}>
						{Icon && <Icon className={classes.icon} />}
						{Icon2}
					</Grid>
					<Grid item xs="auto">
						<Typography variant={isDesktop ? 'h5' : 'h6'}>{title}</Typography>
					</Grid>
				</Grid>

				<Grid
					item
					xs={isDesktop ? 7 : 'auto'}
					container
					spacing={2}
					alignItems="center"
					justify="flex-end"
					wrap="nowrap"
				>
					<Grid item xs="auto">
						<Typography component="div" variant={isDesktop ? 'h5' : 'h6'}>
							{info}
						</Typography>
					</Grid>
					<Grid item xs={1} container alignItems="center">
						{hasAction &&
							(direction === DIRECTIONS.LTR ? (
								<KeyboardArrowRightIcon
									fontSize={isDesktop ? 'large' : 'default'}
								/>
							) : (
								<KeyboardArrowLeftIcon
									fontSize={isDesktop ? 'large' : 'default'}
								/>
							))}
					</Grid>
				</Grid>
			</Grid>
		</ListItem>
	);
};

InfoListItem.propTypes = {
	title: PropTypes.string,
	info: PropTypes.node,
	icon: PropTypes.elementType,
	hasAction: PropTypes.bool,
};

export default InfoListItem;
